import { get, chain } from "lodash"
import { createSelector } from "reselect"
import { getViewType, getMustAggregateFactors, getStyleExposureAggregation } from "modules/portfolio-root/selectors/portfolios"
import { getModelFactorsClassification } from "selectors/modelMetadata"
import { getSortedPositions } from "./positions"
import { getLongAggregation, getShortAggregation, getNetAggregation } from "./aggregations"
import { getSelectedBase } from "modules/portfolio-root/selectors/base"
import { aggregateExposuresFactors } from "helpers/factorClassification/index"
import { VIEW_TYPES } from "helpers/base"

const getAggregationsStatus = state => state.modules.litmus.aggregations
const getBaseExposures = state => get(state, "global.data.portfolioActiveExposure.data.model.simulation")
const getActiveExposures = state => get(state, "global.data.portfolioActiveExposure.data.model.active.exposure.0.factors")

const getBaseRows = createSelector(
  [getSelectedBase, getBaseExposures, getActiveExposures, getMustAggregateFactors, getStyleExposureAggregation, getModelFactorsClassification],
  (selectedBase, baseExposures, activeExposures, mustAggregateFactors, styleAggregation, factorsClassification) => {
    if (!selectedBase) {
      return []
    }

    let baseFactorsExposures = get(baseExposures, ["exposure", 0, "factors"])
    let activeFactorsExposures = activeExposures

    if (mustAggregateFactors) {
      baseFactorsExposures = aggregateExposuresFactors(factorsClassification, baseFactorsExposures, styleAggregation, "net")
      activeFactorsExposures = aggregateExposuresFactors(factorsClassification, activeFactorsExposures, styleAggregation, "net")
    }

    return ([{
      type: "base",
      key: selectedBase.type === "BENCHMARK" ? selectedBase.id : selectedBase.name,
      percEquity: selectedBase.weight,
      factors: chain(baseFactorsExposures)
        .keyBy("id")
        .mapValues(factor => factor.net)
        .value(),
    }, {
      type: "base",
      key: "ACTIVE",
      factors: chain(activeFactorsExposures)
        .keyBy("id")
        .mapValues(factor => factor.net)
        .value(),
    }])
  },
)

export const getRows = createSelector(
  [getAggregationsStatus, getViewType, getSortedPositions, getLongAggregation, getShortAggregation, getNetAggregation, getBaseRows],
  (aggregationsStatus, viewType, { long, short }, longAggregation, shortAggregation, netAggregation, baseRows) => {
    let rows = []

    if (longAggregation) {
      rows.push({ open: aggregationsStatus.long.open, ...longAggregation })
    }

    if (aggregationsStatus.long.open) {
      rows = rows.concat(long)
    }

    if (shortAggregation) {
      rows.push({ open: aggregationsStatus.short.open, ...shortAggregation })
    }

    if (aggregationsStatus.short.open) {
      rows = rows.concat(short)
    }

    if (netAggregation) {
      rows.push(netAggregation)
    }

    if (viewType === VIEW_TYPES.ACTIVE) {
      rows.push(...baseRows)
    }

    return rows
  },
)
